// firebase-config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDmRWJlwaABkc807FdnHMiCEcvOicn7sd8",
  authDomain: "planura-resolve-ifgqho.firebaseapp.com",
  projectId: "planura-resolve-ifgqho",
  storageBucket: "planura-resolve-ifgqho.firebasestorage.app",
  messagingSenderId: "760253414334",
  appId: "1:760253414334:web:d1a92ef841249a734757ef"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
